import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
// material
import { Box } from '@mui/material'
// ----------------------------------------------------------------------
import { useMe } from '../Context/MeContext'

Logo.propTypes = {
  sx: PropTypes.object
}

export default function Logo({ sx }) {
  const { role } = useMe()

  const navigate = useNavigate()

  const checkAuth = () => {
    if (role === 'admin') {
      return navigate('/app/dashboard')
    }
    if (role === 'egresso') {
      return navigate('/app/profile')
    }
    return navigate('/login')
  }

  return (
    <Box
      style={{ cursor: 'pointer' }}
      component="img"
      src="/static/simbolo_egressos.png"
      sx={{ width: 300, ...sx }}
      onClick={checkAuth}
    />
  )
}
